var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoctorSharePost(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#A27FFF",
    fillOpacity: 0.23
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.30045 19.8579L10.225 8.9432C10.261 8.73838 10.3371 8.54266 10.4488 8.36723C10.5605 8.19181 10.7056 8.0401 10.876 7.92078C11.0463 7.80147 11.2385 7.71687 11.4415 7.67184C11.6446 7.62681 11.8545 7.62222 12.0593 7.65833L21.4152 9.30895C21.8287 9.38193 22.1963 9.61618 22.4371 9.96017C22.6779 10.3042 22.7722 10.7297 22.6993 11.1432L20.7747 22.058C20.7387 22.2628 20.6627 22.4585 20.551 22.6339C20.4393 22.8093 20.2941 22.9611 20.1238 23.0804C19.9534 23.1997 19.7612 23.2843 19.5582 23.3293C19.3552 23.3743 19.1453 23.3789 18.9404 23.3428L9.58453 21.6922C9.17102 21.6192 8.80343 21.385 8.56262 21.041C8.32181 20.697 8.2275 20.2714 8.30045 19.8579Z",
    stroke: "#A27FFF",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0689 11.0522L19.3064 12.1519M12.5187 14.1706L18.7562 15.271M11.9692 17.289L15.8674 17.977",
    stroke: "#A27FFF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorSharePost);
export default __webpack_public_path__ + "static/media/doctor_share_post.99181684e5179749d87b623da3b873bf.svg";
export { ForwardRef as ReactComponent };